import { VChip } from 'vuetify/lib/components/VChip';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-body-2"},[_c(VChip,{class:`${_vm.status} white--text caption text-capitalize`,attrs:{"small":""}},[_vm._v(_vm._s(_vm.status))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }